// pages/PageImageToday.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Pagination, Button } from "@mui/material";
import { useNavigate } from "react-router";
import Impressions from "../../../composant/impressions/impressions";
import { useImpressions } from "../../../service/useImpressions";
import ImprimantSucces from "../../../composant/message/imprimanteSucces";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import { Api_Token } from "../../../env";
import ImageCropDialog from "../../../composant/EditImage";

import { useSelector } from "react-redux";

export default function PageImageEvent() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const [images, setImages] = useState([]);
  const [loadingDow, setloadingDow] = useState(false);
  const { user } = useSelector((state) => state.Auth);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const GetImage = useCallback(() => {
    Api_Token.get(`/command/AllImagesEvent?page=${currentPage}`).then((res) => {
      setData(res.data);
      const images = res.data?.data?.map((item) => {
        if (item.ImageTraites && item.ImageTraites.length > 0) {
          return item;
        }
        return null;
      });

      setImages(images.filter(Boolean));
    });
  }, [currentPage]);

  useEffect(() => {
    GetImage();
  }, [GetImage]);

  function telechargeOriginal() {
    setloadingDow(true);
    Api_Token.get("command/DownloadCommandSimpleEvent", {
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "images_original.zip");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Erreur lors du téléchargement :", error);
      })
      .finally(() => {
        setloadingDow(false);
      });
  }

  function telechargeTraite() {
    setloadingDow(true);
    Api_Token.get("command/DownloadCommandTraiteEvent", {
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "images_traite.zip");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error(
          "Erreur lors du téléchargement des images traitées :",
          error
        );
      })
      .finally(() => {
        setloadingDow(false);
      });
  }

  const {
    allImages,
    selectedImages,
    loading,
    openPopup,
    handleSelectImage,
    handleSelectAll,

    setOpenPopup,
    downloadImage,
    editCountImage,
    openImageCropper,
    sendToPrintEvent,
    openCropper,
    setOpenCropper,
    src,
    editImage,
    demonsion,
    background,
    setBackground,
    setText,
    text,
  } = useImpressions(images || [], 0, data?.imprimant, false);

  return (
    <Box>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Images Events
      </Typography>
      <Box sx={{ height: "200vh" }}>
        <Impressions
          allImages={allImages}
          selectedImages={selectedImages}
          handleSelectImage={handleSelectImage}
          downloadImage={downloadImage}
          openImageCropper={openImageCropper}
          editCountImage={editCountImage}
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        mt={2}
        gap={2}
        p={2}
        position="fixed"
        bottom={0}
        width="100%"
        bgcolor="background.paper"
        boxShadow={3}
      >
        <Box textAlign="right">
          <Button
            variant="contained"
            sx={{ height: "80px" }}
            onClick={async () => {
              await sendToPrintEvent();
              await GetImage();
            }}
            color="error"
          >
            Imprimer images
          </Button>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" gap={1}>
            <Button variant="contained" onClick={telechargeTraite}>
              télécharger images traite
            </Button>
            <Button variant="contained" onClick={telechargeOriginal}>
              télécharger images original
            </Button>
          </Box>

          <Box>
            <Pagination
              count={data?.totalPages || 0}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
          <Box display="flex" gap={1}>
            <Button variant="contained" onClick={handleSelectAll}>
              {selectedImages?.length === images?.length
                ? "Désélectionner tout"
                : "Sélectionner tout"}
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate("/admin/event")}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Box>
      <ImageCropDialog
        open={openCropper}
        onClose={() => setOpenCropper(false)}
        src={src}
        background={background}
        setBackground={setBackground}
        backgrounds={user?.Event?.BackgroundEvents || []}
        demonsion={demonsion}
        onSubmit={editImage}
        setText={setText}
        text={text}
        type="event"
        idEvent={user.idEvent}
      />
      <ImprimantSucces
        open={openPopup}
        onClose={() => {
          setOpenPopup(false);
          //navigate("/admin/imagesEvent");
        }}
      />
      <BackLoadingSimple open={loading || loadingDow} />
    </Box>
  );
}
